import { render, staticRenderFns } from "./card-heading.vue?vue&type=template&id=21ce112e"
import script from "./card-heading.vue?vue&type=script&lang=ts"
export * from "./card-heading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ce112e')) {
      api.createRecord('21ce112e', component.options)
    } else {
      api.reload('21ce112e', component.options)
    }
    module.hot.accept("./card-heading.vue?vue&type=template&id=21ce112e", function () {
      api.rerender('21ce112e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/legacy/card/card-heading.vue"
export default component.exports